module.exports = __webpack_public_path__ + "img/card_260790952.e42814e4.png";